// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FooterCopyrightSection from "@eisinc/App/Components/FooterCopyrightSection";
import { getIsCheckoutPage } from "@eisinc/App/Store/Selectors/CheckoutSelector";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

interface FooterContainerStyles {
    container?: InjectableCss;
    topInnerContainer?: InjectableCss;
    subscribeContainer?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const isCheckoutPage = useAppSelector(state => getIsCheckoutPage(state));
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    if (isCheckoutPage) {
        return <FooterCopyrightSection widgetId={id} />;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="FooterContainer">
            <StyledWrapper {...styles.topInnerContainer}>
                <Zone zoneName="LinkList1" contentId={id} />
                <Zone zoneName="LinkList2" contentId={id} />
                <Zone zoneName="LinkList3" contentId={id} />
                <Zone zoneName="LinkList4" contentId={id} />
                <StyledWrapper {...styles.subscribeContainer}>
                    <Zone zoneName="Subscribe" contentId={id} />
                    <Zone zoneName="SocialLinks" contentId={id} />
                </StyledWrapper>
            </StyledWrapper>
            <FooterCopyrightSection widgetId={id} />
        </StyledWrapper>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
